import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmOptions {
  type?: 'delete' | 'warning' | 'info' | 'danger';
  title?: string;
  message?: string;
  details?: string;
  confirmText?: string;
  cancelText?: string;
  confirmIcon?: string;
}

export interface ConfirmDialogState {
  show: boolean;
  options: ConfirmOptions;
  resolve: (value: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private dialogState = new Subject<ConfirmDialogState>();
  dialogState$ = this.dialogState.asObservable();

  confirm(options: ConfirmOptions = {}): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.dialogState.next({
        show: true,
        options,
        resolve
      });
    });
  }

  async delete(message: string, details?: string): Promise<boolean> {
    return this.confirm({
      type: 'delete',
      title: 'Confirm Delete',
      message,
      details,
      confirmText: 'Delete',
      confirmIcon: 'fa-solid fa-trash'
    });
  }

  async warning(message: string, details?: string): Promise<boolean> {
    return this.confirm({
      type: 'warning',
      title: 'Confirm Action',
      message,
      details,
      confirmText: 'Continue'
    });
  }

  close(result: boolean, resolve: (value: boolean) => void): void {
    resolve(result);
    this.dialogState.next({ show: false, options: {}, resolve: () => {} });
  }
}
